import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Order history',
  labels: {
    dummy_order: 'Test order',
    orders_number: 'Number of orders ({{count}})',
    revenue: 'Revenue: {{amount}}',
    tips: 'Tips: {{amount}}',
    cash_sales: ' ({{amount}} Cash)',
    refunds: 'Refunds: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Pickup',
    [OrderMethod.Delivery]: 'Delivery',
    [OrderMethod.OnSite]: 'Table ordering',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'In progress',
    [OrderFulfillmentStatus.Reviewed]: 'In progress',
    [OrderFulfillmentStatus.Accepted]: 'In progress',
    [OrderFulfillmentStatus.Preparing]: 'In progress',
    [OrderFulfillmentStatus.Ready]: 'In progress',
    [OrderFulfillmentStatus.OnDelivery]: 'In progress',
    [OrderFulfillmentStatus.Picked]: 'Completed',
    [OrderFulfillmentStatus.Rejected]: 'Rejected',
  },
  payment_methods: {
    invoice: 'Invoice',
    cash: 'Cash',
    online: 'Online method',
  },
  filters: {
    all: 'All',
  },
  fields: {
    order_placed: 'Order placed',
    order_number: '#',
    customer: 'Customer',
    payment_method: 'Payment method',
    method: 'Type',
    status: 'Status',
    total: 'Total',
  },
  buttons: {
    print: 'Print',
    create_test_order: 'Create test order',
  },
  toasts: {
    failed_to_fetch_orders: 'Failed to load data. Please click on “refresh” icon or try again in 1 minute.',
    something_went_wrong: 'Something went wrong, please try again.',
    failed_to_create_test_order: 'Failed to create test order',
    test_order_created: 'Test order created',
  },
};
